export default "__VITE_ASSET__Cut0HlJR__"